import globalStore from '$$globalStore';
import projectComponent from '../../Project';

function onTaskLinkUpdated(event) {
  const links = event.innerSettings.collaborationItems.filter(link => projectComponent.userHasProject(link.gantt_id));

  if (links.length) {
    globalStore.commit('tasksModel/updateLinks', { links, fromGantt: false }, { root: true });
  }
}

export default onTaskLinkUpdated;
